import { faUser, faUserPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { getClients } from '@redux/features/clientsSlice';
import { Input } from 'components/Input';
import styles from 'pages/Database/Groups/Groups.scss';

export const ClientSelectFields = ({ value: clientIDs = [], onChange, error }) => {
  const [inputValues, setInputValues] = useState(clientIDs.map(() => ''));
  const { clients: allClients } = useSelector((state) => state.clients);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClients());
  }, []);

  const { availableClientsMap, clientsSuggestions } = useMemo(() => {
    const availableClients = allClients.filter(
      (client) => !client.groupID && !clientIDs.includes(client.id) && client.id !== 0
    );

    const map = availableClients.reduce((acc, client) => {
      const fullName = `${client.surname} ${client.name}`;
      acc[fullName] = client.id;
      return acc;
    }, {});

    return {
      availableClientsMap: map,
      clientsSuggestions: Object.keys(map),
    };
  }, [allClients, clientIDs]);

  const handleAdd = () => {
    onChange([...clientIDs, null]);
    setInputValues([...inputValues, '']);
  };

  const handleRemove = (index) => {
    onChange(clientIDs.filter((_, i) => i !== index));
    setInputValues(inputValues.filter((_, i) => i !== index));
  };

  const handleClientChange = (e, index) => {
    const value = e.target.value;
    const newInputValues = [...inputValues];
    newInputValues[index] = value;
    setInputValues(newInputValues);

    const foundID = availableClientsMap[value.trim()];
    const newIDs = [...clientIDs];
    newIDs[index] = foundID || null;
    onChange(newIDs);
  };

  return (
    <div className={styles.dynamicFields}>
      {clientIDs.map((_, index) => (
        <div key={index} className={styles.fieldRow}>
          <Input
            className={styles.dynamicInput}
            value={inputValues[index] || ''}
            name='client'
            placeholder='Клієнт'
            icon={faUser}
            onChange={(e) => handleClientChange(e, index)}
            invalid={error?.[index]}
            errorText={error?.[index]}
            suggestions={clientsSuggestions}
          />
          <button
            className={styles.removeBtn}
            type='button'
            onClick={() => handleRemove(index)}
            aria-label='Видалити клієнта'
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      ))}

      {Object.values(availableClientsMap).length > 0 && (
        <button className={styles.addBtn} type='button' onClick={handleAdd} aria-label='Додати нового клієнта'>
          <FontAwesomeIcon icon={faUserPlus} /> Додати клієнта
        </button>
      )}
    </div>
  );
};
